import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Dialog, DialogContent, Box, Typography, Button,
} from '@mui/material';
import { StorefrontOutlined } from '@mui/icons-material';
import { logout } from '../../store/authSlice';

// Shown when the API returns 403 "This store is inactive" (the store was taken
// offline by an admin). It blocks POS entry for that store — the cashier is cut
// off on login, terminal select, and every request — pointing them at the admin
// rather than treating it as a normal auth failure.
export default function StoreInactiveScreen() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const storeInactive = useSelector((state) => state.auth.storeInactive);

  const handleBackToLogin = () => {
    dispatch(logout());
    navigate('/login', { replace: true });
  };

  return (
    <Dialog
      open={storeInactive}
      maxWidth="xs"
      fullWidth
      disableEscapeKeyDown
      onClose={() => {}}
      PaperProps={{
        sx: {
          borderRadius: '16px',
          p: 0.5,
          textAlign: 'center',
        },
      }}
    >
      <DialogContent sx={{ px: 4, py: 4 }}>
        {/* Icon */}
        <Box
          sx={{
            width: 64, height: 64, borderRadius: '50%',
            bgcolor: '#FFFBEB',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            mx: 'auto', mb: 2.5,
          }}
        >
          <StorefrontOutlined sx={{ fontSize: 32, color: '#F59E0B' }} />
        </Box>

        {/* Title */}
        <Typography sx={{ fontSize: '1.1rem', fontWeight: 800, color: '#1E293B', mb: 1 }}>
          Store Offline
        </Typography>

        {/* Message */}
        <Typography sx={{ fontSize: '0.85rem', color: '#64748B', lineHeight: 1.6, mb: 3 }}>
          This store has been deactivated and can no longer process bills.
          Please contact your administrator to bring it back online.
        </Typography>

        {/* CTA */}
        <Button
          fullWidth
          variant="contained"
          onClick={handleBackToLogin}
          disableElevation
          sx={{
            bgcolor: '#4F46E5', color: '#fff',
            py: 1.3, fontSize: '0.9rem', fontWeight: 700,
            borderRadius: '10px', textTransform: 'none',
            '&:hover': { bgcolor: '#4338CA' },
          }}
        >
          Back to Login
        </Button>
      </DialogContent>
    </Dialog>
  );
}
